import { useMutation, useQueryClient } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'
import { reportUnexpectedError } from '../../../lib/reportError'
import type { AppSettings } from './useAppSettings'

interface SaveResult {
  success: boolean
  error?: string
}

async function saveAppSettings(settings: AppSettings): Promise<void> {
  const { data, error } = await supabase.rpc('update_app_settings', {
    p_max_stamps_per_transaction: settings.maxStamps,
    p_receipt_reference_enabled: settings.receiptReferenceEnabled,
    p_referral_program_enabled: settings.referralProgramEnabled,
    p_cashier_stamp_correction_enabled: settings.cashierStampCorrectionEnabled,
    p_cashier_reward_restore_enabled: settings.cashierRewardRestoreEnabled,
  })

  if (error) {
    reportUnexpectedError(error)
    throw error
  }
  const result = data as SaveResult
  if (!result?.success) {
    const failure = new Error(result?.error ?? 'save_failed')
    reportUnexpectedError(failure)
    throw failure
  }
}

export function useSaveAppSettings() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: saveAppSettings,
    onSuccess: () => void queryClient.invalidateQueries({ queryKey: ['app-settings'] }),
  })
}